// extracted by mini-css-extract-plugin
module.exports = {"share":"ShareAMemory_share__ZNAgz"};